import React from 'react';
import { ChoiceList, DisplayText } from '@superops/ui-design-system';
import { DeviceType } from '../types';
import { FormattedMessage } from 'react-intl';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { SVGIcon } from '@superops/super-icons';
interface DeviceTypeSelectorProps {
  selectedDevice: DeviceType;
  onDeviceChange: (device: DeviceType) => void;
}

const DeviceTypeSelector: React.FC<DeviceTypeSelectorProps> = ({
  selectedDevice,
  onDeviceChange
}) => {
  const flags = useFlags();
  return (
    <div className="flex g20">
      <div className="flex actr g10">
        <SVGIcon name="IOSLine" />
        <div className="w200">
          <DisplayText size="large" isRequired>
            <FormattedMessage id="common.device" />
          </DisplayText>
        </div>
      </div>
      <ChoiceList
        choices={[
          ...(flags.macMdm ? [{ label: 'Mac', value: 'Mac' }] : []),
          {
            label: 'iPhone',
            value: 'iPhone'
          },
          { label: 'iPad', value: 'iPad' }
        ]}
        selected={[selectedDevice]}
        onChange={(selected: string[]) =>
          onDeviceChange(selected[0] as DeviceType)
        }
        horizontal
        title=""
      />
    </div>
  );
};

export default DeviceTypeSelector;
